export const DeviceModes = [
    { id: 'A', name: 'Auto', description: 'Dim at Isha until Sunrise' },
    { id: 'N', name: 'Normal', description: 'Always normal' },
    { id: 'D', name: 'Dim', description: 'Always dim' }
]